<template>
    <CCol v-bind="$attrs" class="custom-searchable-input" v-c-clickaway="hideIt">
        <ValidationProvider tag="div" :vid="vid" :name="name" :rules="rules" v-slot="{ errors }">
            <input :value="value" type="hidden" />
            <CInput
                :description="description"
                :disabled="disabled"
                :value="searchedValue"
                @input="emitInput"
                :dir="direction"
                :type="type"
                :prepend="prepend"
                :placeholder="placeholder"
                @focus="showIt"
            >
                <template #label>
                    <slot :name="label">{{ autoLabel }}</slot>
                    <span v-if="required" class="text-danger">*</span>
                </template>

                <template #invalid-feedback>
                    <span class="invalid-feedback d-block">{{ errors[0] }}</span>
                </template>

                <template #label-after-input>
                    <ul
                        :key="activeEl"
                        class="result-list border-light shadow-sm"
                        :style="{ maxHeight: resultListMaxHeight + 'px' }"
                        tabindex="0"
                        v-if="!showLoading && !errors[0] && activeEl"
                    >
                        <div v-for="(item, index) in (limit > 0 ? matchedItems.slice(0, limit) : matchedItems)" :key="index">

                            <li v-if="item[itemValue]" @click="setValue(item)">
                                <slot name="customItem" v-bind:item="item">{{ item[itemValue] }}</slot>
                            </li>
                            <CCustomUl
                                v-if="item.childs && item.childs.length > 0"
                                :item="item.childs"
                                @customUl="setValue"
                            />
                        </div>
                    </ul>
                    <div
                        v-else-if="showLoading"
                        class="result-list border-light shadow-sm"
                    >در حال بررسی...</div>
                </template>

                <template v-for="(_, slot) in $slots">
                    <template :slot="slot">
                        <slot :name="slot"></slot>
                    </template>
                </template>
            </CInput>
        </ValidationProvider>
    </CCol>
</template>

<script>
import { DefaultInputProps } from './defaultProps'
import CCustomUl from './CCustomSearchableInput/CCustomUl'

export default {
    name: 'CCustomSearchableInput',

    components: {
        CCustomUl,
    },

    props: {
        ...DefaultInputProps,
        items: {
            default: () => [],
            type: Array
        },
        itemValue: {
            default: 'label',
            type: String,
        },
        showLoading: {
            default: false,
            type: Boolean,
        },
        resultListMaxHeight: {
            default: 150,
            type: Number
        },
        limit: {
            default: 0,
            type: Number
        }
    },

    data() {
        return {
            localMatchedItems: undefined,
            localSearchedValue: undefined,
            activeEl: false,
            fList: false,
            founded: [],
        }
    },

    computed: {
        direction() {
            return this.ltr ? 'ltr' : 'rtl';
        },
        autoLabel() {
            return this.label === '' ? this.name : this.label
        },
        matchedItems: {
            get() {
                if (this.localMatchedItems === undefined) {
                    return this.items
                }

                return this.localMatchedItems
            },
            set(val) {
                this.localMatchedItems = val
            },
        },
        searchedValue: {
            get() {
                if (this.localSearchedValue === undefined) {
                    // Notice: typeof null is 'object'
                    return typeof this.value === 'object' && this.value ? this.value[this.itemValue] : this.value
                }

                return this.localSearchedValue
            },
            set(val) {
                this.localSearchedValue = val
            },
        }
    },

    watch: {
        showLoading(val) {
            if (val) {
                return
            }
            const newVal = typeof this.value === 'object' ? this.value.label : this.value

            let isChild = false
            this.items.forEach(item => {
                if (item.childs && item.childs.length > 0) {
                    isChild = true
                }
            })

            if (isChild) {
                this.founded = []
                if (newVal.length !== 0) {
                    this.nesting(this.items, newVal)
                    this.matchedItems = this.founded
                } else {
                    this.matchedItems = this.items
                }

            } else {
                if (newVal) {
                    // in this section we only show the matched item
                    this.matchedItems = this.items.find(item => {
                        if (typeof item === 'string') {
                            return item.indexOf(newVal) !== -1 ? item : []
                        }

                        if (typeof item === 'object') {
                            return item[this.itemValue] && item[this.itemValue].indexOf(newVal) !== -1 ? item : []
                        }

                        return false
                    })
                }

                this.matchedItems = this.items.filter(item => {
                    if (typeof item === 'string') {
                        return item.indexOf(newVal) !== -1 ? true : false
                    }

                    if (typeof item === 'object') {
                        return item[this.itemValue] && item[this.itemValue].indexOf(newVal) !== -1 ? true : false
                    }

                    return false
                })
            }
        },
        searchedValue(newVal) {
            let isChild = false
            this.items.forEach(item => {
                if (item.childs && item.childs.length > 0) {
                    isChild = true
                }
            })

            if (isChild) {
                this.founded = []
                if (newVal.length !== 0) {
                    this.nesting(this.items, newVal)
                    this.matchedItems = this.founded
                } else {
                    this.matchedItems = this.items
                }

            } else {
                if (this.value) {
                    // in this section we only show the matched item
                    this.matchedItems = this.items.find(item => {
                        if (typeof item === 'string') {
                            return item.indexOf(newVal) !== -1 ? item : []
                        }

                        if (typeof item === 'object') {
                            return item[this.itemValue] && item[this.itemValue].indexOf(newVal) !== -1 ? item : []
                        }

                        return false
                    })
                }

                this.matchedItems = this.items.filter(item => {
                    if (typeof item === 'string') {
                        return item.indexOf(newVal) !== -1 ? true : false
                    }

                    if (typeof item === 'object') {
                        return item[this.itemValue] && item[this.itemValue].indexOf(newVal) !== -1 ? true : false
                    }

                    return false
                })
            }
        },
        value(newVal) {
            if (!newVal) {
                this.searchedValue = ''
            }
        }
    },

    methods: {
        nesting(elmnt, text) {
            for (let i = 0; i < elmnt.length; i++) {
                elmnt[i].label.startsWith(text) ? this.founded.push(elmnt[i]) : null
                if (elmnt[i].childs && elmnt[i].childs.length > 0) {
                    this.nesting(elmnt[i].childs, text)
                }
            }
        },
        emitInput(value) {
            this.searchedValue = value
            this.$emit('input', {
                label: value,
                value: ''
            })
        },
        setValue(item) {
            if (typeof item === 'string') {
                this.$emit('input', {
                    label: item,
                    value: item
                })
                this.searchedValue = item
            }

            if (typeof item === 'object') {
                this.$emit('input', item)
                this.searchedValue = item[this.itemValue]
            }

            this.hideIt()
        },
        hideIt() {
            this.activeEl = false
        },
        showIt() {
            this.activeEl = true
        }
    },
}
</script>

<style>
.result-list {
    top: 110%;
    position: absolute;
    background: #fff;
    width: 100%;
    border-radius: 5px;
    z-index: 9999;
    overflow-y: scroll;
    padding: 5px 20px;
}
.result-list li {
    cursor: pointer;
}
</style>